// Fires a Pixel event and its Conversions API mirror with a shared event_id,
// which is how Meta dedupes the two deliveries of the same event instead of
// double-counting it. Analytics must never break the feature it's attached
// to, so every call here swallows its own errors.

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

function generateEventId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// Meta's own standard event names — anything else must go through fbq('trackCustom', ...)
// instead of fbq('track', ...), or the pixel logs a console warning and Events Manager
// won't recognize it as a supported standard event.
const STANDARD_EVENTS = new Set(['PageView', 'Contact', 'Lead', 'ViewContent']);

// eventParams: extra props for the fbq() call (e.g. { form_name }).
// userData: { email, phone, firstName, lastName } — hashed server-side for CAPI match quality.
export function trackEvent(eventName, { eventParams, userData } = {}) {
  const eventId = generateEventId();

  try {
    if (window.fbq) {
      const method = STANDARD_EVENTS.has(eventName) ? 'track' : 'trackCustom';
      window.fbq(method, eventName, eventParams || {}, { eventID: eventId });
    }
  } catch {
    // ignore — a broken pixel stub must not block the CAPI mirror below
  }

  try {
    fetch('/api/capi', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        event_name: eventName,
        event_id: eventId,
        event_source_url: window.location.href,
        user_data: {
          ...userData,
          fbp: getCookie('_fbp'),
          fbc: getCookie('_fbc'),
        },
      }),
    }).catch(() => {
      // ignore — network/ad-blocker failures must not affect the user-facing outcome
    });
  } catch {
    // ignore
  }
}
